module.exports = __webpack_public_path__ + "static/media/vuejs-logo.08f0c81f.png";